export default "__VITE_ASSET__6ac11c99__$_?component__"